import { Directive, ElementRef, HostBinding, HostListener, Renderer2 } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LightboxService } from './lightbox.service';
import { LightboxImage } from './lightbox-image';
import { resizeImage } from './resize-image';
import { ViewportSize } from './viewport-size';

@Directive({
  selector: 'img[pcsLightbox]'
})
export class LightboxDirective {

  private loaded = new BehaviorSubject(false);
  private loaded$ = this.loaded.asObservable();

  @HostBinding('class')
  private readonly rootClasses = 'lightbox';

  private get imageElement(): HTMLImageElement {
    return this.imageElementRef.nativeElement;
  }

  constructor(
    private readonly imageElementRef: ElementRef,
    private readonly renderer: Renderer2,
    private readonly lightboxService: LightboxService
  ) {
  }

  @HostListener('load')
  onLoad() {
    this.loaded.next(true);
  }

  @HostListener('click')
  onClick() {
    this.loaded$.pipe(
      filter(loaded => loaded),
      take(1)
    ).subscribe(() => {
      this.lightboxService.open(this.lightboxImage());
    });
  }

  @HostListener('mouseover')
  onMouseIn() {
    this.renderer.addClass(this.imageElement, 'lightbox-mouseover');
  }

  @HostListener('mouseout')
  onMouseOut() {
    this.renderer.removeClass(this.imageElement, 'lightbox-mouseover');
  }

  private lightboxImage(): LightboxImage {
    const viewportSize = new ViewportSize(window.innerWidth, window.innerHeight);
    return {
      image: this.imageElement.src,
      imageSize: resizeImage({
        width: this.imageElement.naturalWidth,
        height: this.imageElement.naturalHeight
      }, viewportSize)
    };
  }
}
